import apiClient from "../server";

export const fetchUsers = async (page, limit, isActive) => {
  try {
    let url = `/users/all?pagination=true&page=${page}&limit=${limit}`;
    if (isActive !== undefined) {
      url += `&isActive=${isActive}`;
    }
    const response = await apiClient.get(url);
    console.log("API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching publications:", error);
    throw error;
  }
};

export const fetchAllUsers = async (isActive) => {
  try {
    let allUsers = [];
    let page = 1;
    const limit = 100;

    while (true) {
      const response = await fetchUsers(page, limit, isActive);
      if (!response.data || response.data.length === 0) {
        break;
      }
      allUsers = [...allUsers, ...response.data];
      page++;
    }

    return { data: allUsers };
  } catch (error) {
    console.error("Error fetching all users:", error);
    throw error;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await apiClient.get(`/users/get/${userId}`);
    console.log("user : ", response.data);
    return response.data.data;
  } catch (error) {
    console.error("error fetching user : ", error);
  }
};

export const UpdateUser = async (userId, user) => {
  try {
    const response = await apiClient.patch(`/users/update/${userId}`, user);
    console.log(response);
    return response;
  } catch (error) {
    console.error("error updating user", error);
  }
};

export const DeleteUser = async (userId) => {
  try {
    const response = await apiClient.delete(`users/delete/${userId}`);
    console.log(response);
    return response;
  } catch (error) {
    console.error("error deleting user", error);
  }
};

export const createUser = async (userData) => {
  try {
    const response = await apiClient.post("/users/create", userData);
    console.log("User created:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};
export const changePassword = async (userId, passwordData) => {
  try {
    const response = await apiClient.put(
      `/users/password-change/${userId}`,
      passwordData,
    );
    console.log("Password changed:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

export const searchUsers = async (query, options = {}) => {
  try {
    const { limit = 20 } = options;
    const response = await apiClient.get(`/users/all?pagination=true&page=1&limit=${limit}&search=${encodeURIComponent(query)}`);
    return {
      data: response.data.data || [],
      total: response.data.pagination?.total || 0
    };
  } catch (error) {
    console.error("Error searching users:", error);
    throw error;
  }
};
